<template lang="">
    <div class="mb-10 md:mb-0 flex flex-wrap">
        <div class="sm:w-1/3 lg:w-auto cursor-pointer" v-for="key in Object.keys(continuityBoard)" @click="loadClipPlayback(key)">
            <div class="take relative z-10">
                <div class="title">
                    <div class="capitalize flex space-x-2">
                    <div> {{key}} </div>
                    <svg class="animate-spin mr-3 h-4 w-4 mt-0.5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" v-show="continuityBoard[key].loading == true">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                     </div>
                </div>
                <button class="removeTakeButton cursor-pointer" @click.stop="persistContinuityClip(key, true)" v-if="!isDirector">
                    <svg class="w-5 h-5 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 1.6a8.4 8.4 0 1 0 0 16.8 8.4 8.4 0 0 0 0-16.8zm5 9.4H5V9h10v2z"/></svg>
                </button>
                <div class="takeName transition" v-if="continuityBoard[key]">
                    {{continuityBoard[key].name}}
                </div>
                <div data-tippy-content="This take was taken in with the viewport rotated. Support to display these takes correctly is coming soon." class="text-red-500 absolute bottom-8 right-2 hidden" v-if="continuityBoard[key].rotation != null && continuityBoard[key].rotation != 0">
                    <!-- Heroicon name: solid/exclamation-sign -->
                    <svg class="w-5 h-5 fill-current" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M8.25706 3.09882C9.02167 1.73952 10.9788 1.73952 11.7434 3.09882L17.3237 13.0194C18.0736 14.3526 17.1102 15.9999 15.5805 15.9999H4.4199C2.89025 15.9999 1.92682 14.3526 2.67675 13.0194L8.25706 3.09882ZM11.0001 13C11.0001 13.5523 10.5524 14 10.0001 14C9.44784 14 9.00012 13.5523 9.00012 13C9.00012 12.4477 9.44784 12 10.0001 12C10.5524 12 11.0001 12.4477 11.0001 13ZM10.0001 5C9.44784 5 9.00012 5.44772 9.00012 6V9C9.00012 9.55228 9.44784 10 10.0001 10C10.5524 10 11.0001 9.55228 11.0001 9V6C11.0001 5.44772 10.5524 5 10.0001 5Z" clip-rule="evenodd"/></svg>
                </div>

                <div class="text-white text-shadow absolute right-2 bottom-2 transition" v-if="continuityBoard[key].duration_in_seconds != null && continuityBoard[key].duration_in_seconds > 0">
                    {{continuityBoard[key].duration_in_seconds}}s
                </div>
                <!-- drop zone wrapper -->
                <div v-if="continuityBoard[key] && !isDirector" class="dropzone-wrapper absolute z-10 inset-0 m-auto flex items-center justify-center" :class="{'bg-blue-100': isOver == key}" >
                    <!-- drop zone -->
                    <div class="absolute z-10 inset-0 m-auto" :draggable="continuityBoard[key].url != null"
                        @dragstart="handleDragStart($event, key)" @dragend="handleDragEnd($event, key)"
                        @dragenter="handleDragEnter($event, key)" @dragleave="handleDragLeave($event, key)"
                        @dragover="handleDragOver($event)"               @drop='onDrop($event, key)'
                        @mouseover="handleHoverClip($event, key)" @mouseleave="handleMouseLeave($event, key)"
                        ></div>
                    <!-- drop zone text -->
                    <div class="text-lg font-medium text-blue-800" v-if="isOver == key">
                        Drop the video
                    </div>
                    <!-- Position marker -->
                    <div class="markerPosition opacity-0 h-28 my-2 w-1 bg-white rounded-md absolute top-0"  v-show="enableScrubbing && continuityBoard[key].loading == false && (continuityBoard[key].rotation == 0 || continuityBoard[key].rotation == 180)"></div>
                </div>
                <div v-if="continuityBoard[key]" class="relative -z-1 h-full w-full" :class="{'bg-black': continuityBoard[key].thumbnail_url && (continuityBoard[key].rotation == 90 || continuityBoard[key].rotation == 270)}">
                    <img v-show="continuityBoard[key].thumbnail_url" :src="continuityBoard[key].thumbnail_url" class="absolute inset-0 z-10 object-cover w-full transform" :class="getRotationAngle(continuityBoard[key].rotation)"/>
                    <div v-show="!continuityBoard[key].url" class="absolute inset-0 flex items-center justify-center text-gray-500 font-medium">
                        <div>
                            No clip selected
                        </div>
                    </div>
                </div>
                </div>
            </div>
        <img src="" id="ghostFrame" class="rounded-md font-medium flex items-center justify-center h-16 w-32 bg-blue-700 text-white absolute -left-80" />
         <!-- Playback modal -->
    <modal :showModal="showPlaybackModal" @close="showPlaybackModal = false; backToCue();" classSize="lg:max-w-4xl">
      <div id="thumbnails" class="hidden">This shouldnt be shown</div>
      <div class="relative overflow-hidden" data-id="continuityViewport" id="readyToPlay" v-if="selectedTake">
        <div id="mask-before" class="absolute opacity-50 bg-black"></div>
        <div id="mask-after" class="absolute opacity-50 bg-black"></div>
        <video volume="1" :src="selectedTake.url" class="w-full playback left-0 right-0 mx-auto transform transition-all duration-300 bg-black" 
        :class="[getRotationAngle(selectedTake.rotation), 'continuityPlayback'+this.uniqueId]" :id="'continuityPlayback'+this.uniqueId" type="video/h264" preload="auto" playsinline></video>
        <div class="video-overlay absolute inset-0"">
            <!-- Video Controls -->
            <div class="video-controls" id="continuity_controls"></div>
            <!-- Selected key -->
            <div class="text-white text-2xl px-4 py-2 absolute top-0 left-0 z-10 opacity-75 capitalize" id="tag">{{selectedKey}}</div>
            <!-- selected name -->
            <div class="text-white text-2xl px-4 py-2 absolute top-0 right-0 z-10 opacity-75" id="name">{{selectedTake.name}}</div>
        </div>
        <div class="processing text-3xl text-white absolute top-0 left-0 pt-32 h-full w-full text-center bg-black" v-show="processingClip">
          <div class="loader mx-auto mb-10"></div>
          Loading video...
        </div>
      </div>
      <div class="mt-5 flex justify-between px-2 space-x-2">
          <div class="flex space-x-2 flex-grow max-w-48">
              <button class="btn btn-primary" @click="backToCue" :class="{'w-1/2 md:w-auto': !isDirector, 'w-full': isDirector}"> Back to cue </button>
              <button class="w-1/2 md:w-auto btn btn-secondary" @click="setNewCue" v-show="!isDirector"> Set new cue </button>
          </div>
          <div :class="{'w-1/2 bg-gray-100 dark:bg-gray-800 rounded-md flex items-center': isDirector}" >
              <button class="underline text-lg flex items-center justify-center" 
              :class="{'w-1/2 md:w-auto float-right': !isDirector,'w-full': isDirector}"
              @click="showPlaybackModal = false; backToCue();">
                  <!-- Close icon -->
                  <svg xmlns="http://www.w3.org/2000/svg" class="fill-current h-4 w-4 inline-block" viewBox="0 0 20 20"><path d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"/></svg>
                  <div class="pl-1"> Close </div>
              </button>
          </div>
      </div>
    </modal>
    </div>
</template>
<script>
import axios from 'axios'
import { generateThumbnails, captureFrameFromURL } from 'utils/thumbnails';
import tippy from 'tippy.js';
import commandsManager from 'general/CommandsManager'

import { changeAudioDestination } from 'webrtc/mediaDevices';

import { detectBrowser } from 'utils/browser';
import  CustomPlayer from 'utils/custom-player';
export default {
    props: ["isDirector"],
    data() {
        return {
            isOver: null,
            draggingOver: null,
            hoveringOver: null,
            continuityBoard: {
                previous: {},
                current: {},
                next: {}
            },
            // for playback
            selectedKey: null,
            selectedTake: null,
            showPlaybackModal: false,
            processingClip: false,
            enableScrubbing: false,
            currentAnimationFrame: null,

            customPlayer: null,
            uniqueId: null,
        }
    },
    mounted() {
        this.uniqueId = Math.random().toString(36).substring(7);
        if(!this.isDirector)
            this.loadContinuityBoard()
        // resize video when window resizes
        window.addEventListener('resize', this.resizeVideo);
        // set commands
        commandsManager
            .registerNewCommand('set_continuity', (data) => {
                this.setContinuityBoard(data.args);
            });
    },
    methods: {
        // preview (seek)
        async handleMouseMove(event){
            // if theres no clip dont do anything
            if(this.hoveringOver == null || this.continuityBoard[this.hoveringOver].url == null) return;

            event = event || window.event; // IE-ism
            let clip = $("#continuity_" + this.hoveringOver)[0];
            let rect = clip.getBoundingClientRect();
            let width = rect.width;
            let x = rect.left + window.scrollX;
            clip.currentTime = await this.getClipDuration(clip) * ((event.pageX - x) / width);
            $(".markerPosition").css("left", (event.pageX - x) + "px")
        },
        async getClipDuration(clip){
          if (clip == null) { alert("Clip is null") }
            while(clip.duration === Infinity || isNaN(clip.duration)) {
                await new Promise(r => setTimeout(r, 100));
                clip.currentTime = 10000000*Math.random();
            }
            return clip.duration
        },
        addClipPreviewListener(){
            document.onmousemove = this.handleMouseMove;
        },
        removeClipPreviewListener(){
            document.onmousemove = null;
        },
        handleMouseLeave(event, source){
            this.hoveringOver = null;
            this.setupVideos()
            if (this.enableScrubbing)
                this.removeClipPreviewListener();
        },
        handleHoverClip(event, source){
            // do not allow seek if the clip is empty
            if (this.continuityBoard[source] == null || this.continuityBoard[source].url == null ||
                (this.continuityBoard[source].rotation != 0 && this.continuityBoard[source].rotation != 180)
               ) return;
            this.hoveringOver = source;
            if (this.enableScrubbing) this.addClipPreviewListener();
        },
        // Drag and Drop
        handleDragEnd(){
            this.isOver = null
            this.draggingOver = null;
        },
        handleDragOver(event){
            // to allow drops
            event.preventDefault();
        },
        handleDragLeave(event, dest){
            this.isOver = null;
        },
        handleDragEnter(event, dest){
            // To allow drops https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#droptargets
            event.preventDefault();
            this.isOver = dest;
        },
        handleDragStart(event, source){
            event.dataTransfer.dropEffect = 'move'
            event.dataTransfer.effectAllowed = 'move'
            event.dataTransfer.setData('source', source)
            event.dataTransfer.setData('type', 'CONTINUITY')

            this.draggingOver = source;

            // create custom draggable image
            const elem = document.getElementById("ghostFrame");
            elem.src = this.continuityBoard[source].thumbnail_url;
            const rect = elem.getBoundingClientRect()
            event.dataTransfer.setDragImage(elem, rect.width/2, rect.height/2);
        },
        onDrop(event, dest){
            this.isOver = null;
            this.draggingOver = null;
            const draggingType = event.dataTransfer.getData('type')
            if (draggingType == 'CONTINUITY'){
                const source = event.dataTransfer.getData('source')
                if (source == dest) return; // if the source and dest are the same do not execute drag and drop

                this.continuityBoard[dest] = this.continuityBoard[source];
                // persist both clips
                this.persistContinuityClip(dest)
                this.persistContinuityClip(source, true)
                window.setTimeout(()=>{
                    this.setupVideos()
                }, 50)
            }
            else if(draggingType == 'VIDEO_TAKE'){
                const take = JSON.parse(event.dataTransfer.getData('take'));
                this.continuityBoard[dest] = {
                    id: take.id,
                    name: take.name,
                    url: take.file_url,
                    thumbnail_url: take.thumbnail_url,
                    duration_in_seconds: take.duration_in_seconds,
                    starts_at: 1.0
                }
                this.persistContinuityClip(dest)
            }
        },
        // called to update the Continuity Board
        setContinuityBoard(continuityBoard){
            this.continuityBoard = continuityBoard;
            this.setupVideos();
        },
        loadContinuityBoard(){
            axios.get('/rooms/' + room_key + '/continuity/').then(response => {
                this.continuityBoard = response.data;
                window.setTimeout(() => {
                    this.setupVideos()
                }, 100)
            })
        },
        async persistContinuityClip(key, removeTake = false){
            // parameters
            let id = this.continuityBoard[key].id;
            let starts_at = this.continuityBoard[key].starts_at
            let url = '/rooms/' + room_key + '/continuity/' + key

            // if remove just remove
            if (removeTake){
                // update continuity
                id = null
                starts_at = null
            }
            const data = new FormData();
            try {
                let thumbnail = await captureFrameFromURL(this.continuityBoard[key].url, starts_at);
                data.append('continuity['+key+'][thumbnail]', thumbnail, `${this.continuityBoard[key].name}.png`);
            }
            catch{
                console.error("error generating thumbnail");
            }
            data.append('authenticity_token', authenticity_token);
            data.append('continuity['+key+'][take_id]', id);
            data.append('continuity['+key+'][starts_at]', starts_at);

            this.persistToServer(url, data, (response)=>{
                if(removeTake){
                    this.continuityBoard[key].id = null
                    this.continuityBoard[key].name = null
                    this.continuityBoard[key].duration_in_seconds = 0
                    this.continuityBoard[key].thumbnail_url = null
                    this.continuityBoard[key].starts_at = 0
                    this.continuityBoard[key].url = null
                    this.continuityBoard[key].rotation = null
                }else{
                    this.continuityBoard[key] = response.data.continuity[key];
                    this.setupVideos()
                }
                this.sendContinuity();
            })
        },
        sendContinuity(){
            commandsManager.sendAllCommand('set_continuity', this.continuityBoard)
        },
        persistToServer(url, data, callback){
            axios.post(url, data)
                .then(callback)
                .catch(err =>{
                    console.error(err)
                })
        },
        setNewCue(){
            this.continuityBoard[this.selectedKey].starts_at = document.getElementById("continuityPlayback"+this.uniqueId).currentTime;
            this.selectedTake.starts_at = this.continuityBoard[this.selectedKey].starts_at;
            this.persistContinuityClip(this.selectedKey);
        },
        async setupVideos(){
            for (const key of Object.keys(this.continuityBoard)){
                if (this.continuityBoard[key].starts_at == null) continue;
                // get durations
                this.continuityBoard[key].loading = false;
            }
        },
        async loadClipPlayback(key){
            // show the modal first so the user now whats going on
            this.showPlaybackModal = true;
            this.processingClip = true;

            this.selectedKey = key;
            this.selectedTake = null;
            this.selectedTake = this.continuityBoard[key];

            console.log("selected take for cue", this.selectedTake.duration_in_seconds, this.continuityBoard)

            if (this.selectedTake.url == null){
                this.selectedKey = null;
                this.selectedTake = null;
                return;
            }
            // sleep for a bit to send the loading video request before trying
            // to find the clip duration
            await new Promise((r) => setTimeout(r, 200));

            // Update routes after creating the video
            window.setTimeout(() => {
                if (this.customPlayer == null) {
                    const videoEl = document.getElementById("continuityPlayback"+this.uniqueId);
                    const controlsEl = document.querySelector("#continuity_controls");
                    this.customPlayer = new CustomPlayer(videoEl, controlsEl)
                }
                this.customPlayer.setupCustomControls()
                changeAudioDestination()
            }, 200)

            generateThumbnails('continuityPlayback'+this.uniqueId, 'thumbnails').then(() => {
                this.processingClip = false;
                // this.setupClipListeners();
                // set to begin on cue
                var videoEl = document.getElementById("continuityPlayback"+this.uniqueId);
                videoEl.currentTime = this.selectedTake.starts_at;
                videoEl.muted=false;
            })
            },
            setupClipListeners(){
                // do not setup Plyr if its an iPhone
                window.continuityPlaybackPlayer = new Plyr('#continuityPlayback'+this.uniqueId, {
                    ratio: '16:9',
                    storage: { enabled: false },
                    keyboard: { focused: false, global: false },
                    controls: [
                        'play', // Play/pause playback
                    'progress', // The progress bar and scrubber for playback and buffering
                    'fullscreen', // Toggle fullscreen
                    ],
                });

                const maskBefore = $("[data-id='continuityViewport'] #mask-before");
                const maskAfter = $("[data-id='continuityViewport'] #mask-after");
                // remove old masks (if they exist)
                $("[data-id='continuityViewport'] .plyr__video-wrapper #mask-before").remove();
                $("[data-id='continuityViewport'] .plyr__video-wrapper #mask-after").remove();
                // append masks
                maskBefore.appendTo("[data-id='continuityViewport'] .plyr__video-wrapper");
                maskAfter.appendTo("[data-id='continuityViewport'] .plyr__video-wrapper");


                // set to begin on cue
                document.getElementById("continuityPlayback"+this.uniqueId).currentTime = this.selectedTake.starts_at;

                const videoEl = $('#continuityPlayback'+this.uniqueId);
                videoEl.currentTime = 0;
                window.setTimeout(()=>{
                    window.continuityPlaybackPlayer.on('enterfullscreen', (event) => {
                    window.setTimeout(()=>{
                        this.resizeVideo();
                        const videoElWrapper = videoEl.parents('.plyr--video');;
                        if(this.angle == 90 || this.angle == 270){
                        videoEl.css('top', videoElWrapper.height()/8)
                        }
                    } , 100)
                    });

                    window.continuityPlaybackPlayer.on('exitfullscreen', (event) => {
                        window.setTimeout(()=>{
                            this.resizeVideo();
                            videoEl.css('top', '0rem');
                        } , 100)
                    });
                }, 1000);
            },
            backToCue(){
                // set to begin on cue
            var video = document.getElementById("continuityPlayback"+this.uniqueId);
            video.currentTime = this.selectedTake.starts_at;
            var playButton = document.querySelector("#continuity_controls .play-button");
                if (video.paused == false) {
                    video.pause();
                    playButton.innerHTML = "Play";
                }
            },
            resizeVideo(){
                const videoEl = $('#continuityPlayback'+this.uniqueId);
                const videoElWrapper = videoEl.parents('.plyr--video');;
                if(this.selectedTake == null) return;
                const rotation = parseInt(this.selectedTake.rotation);
                if(rotation == 0 || rotation == 180){
                    videoEl.width(videoElWrapper.width());
                }
                if(rotation == 90 || rotation == 270){
                    videoEl.width(videoElWrapper.height());
                }
                // redraw mask
                window.setTimeout(()=>{
                this.drawMaskViewport();
                }, 1000)
            },
            getRotationAngle(rotation){
                this.resizeVideo();
                if (rotation == 0){   return ''; }
                if (rotation == 90){  return '-rotate-90 w-3/4' }
                if (rotation == 180){ return '-rotate-180' }
                if (rotation == 270){ return '-rotate-270 w-3/4' }
            },
            drawMaskViewport(){
                let ratio = "16:9"
                try {
                    ratio = this.selectedTake.aspect_ratio.split(":").reduce((a, b) => a/b);
                } catch (error) {
                    console.log("error getting aspect ratio", error)
                }
                // left right
                const maskBefore = $("[data-id='continuityViewport'] #mask-before")
                const maskAfter = $("[data-id='continuityViewport'] #mask-after")

                const verticalClassListLeft = "inset-y-0 left-0"
                const verticalClassListRight = "inset-y-0 right-0"
                if (ratio < 16 / 9) {
                    maskBefore.addClass(verticalClassListLeft).removeClass("inset-x-0 top-0");
                    maskAfter.addClass(verticalClassListRight).removeClass("inset-x-0 bottom-0");
                    maskBefore.css("height", "initial");
                    maskAfter.css("height", "initial");
                    const height = maskBefore.height();
                    maskBefore.css("width", (height * (16 / 9 - ratio / 1)) / 2);
                    maskAfter.css("width", (height * (16 / 9 - ratio / 1)) / 2);
                } else {
                    // top bottom
                    maskBefore
                    .removeClass(verticalClassListLeft)
                    .addClass("inset-x-0 top-0");
                    maskAfter
                    .removeClass(verticalClassListRight)
                    .addClass("inset-x-0 bottom-0");
                    maskBefore.css("width", "initial");
                    maskAfter.css("width", "initial");
                    const width = maskBefore.width();
                    maskBefore.css("height", (width / 2) * (9 / 16 - 1 / ratio));
                    maskAfter.css("height", (width / 2) * (9 / 16 - 1 / ratio))
                }
            },
        },
}
</script>
<style lang="scss">
.-rotate-270{
    transform: rotate(-270deg)!important;
}
.dropzone-wrapper{
    .markerPosition{
        transition: opacity 0.1s ease-in;
    }
    &:hover .markerPosition{
        opacity: 1;
    }

}
.dark .take{
	@apply bg-gray-800 border-gray-900;
}
.take{
    @apply relative overflow-hidden border bg-gray-50;
    @media (min-width: 1200px) {
        height: 9rem;
    }
	@media screen and (max-width: 768px){
        height: 9rem;
	}

    aspect-ratio: 16/9;

    .removeTakeButton{
        @apply px-2 py-1 absolute top-0 right-0 z-20 opacity-75 hover:opacity-100 mt-1 mr-1 text-white;
    }
    .title{
        @apply bg-blue-100 font-medium text-blue-900 px-1 absolute top-0 left-0 z-20 mt-2 ml-2 opacity-75 flex items-center rounded-md;
    }
    .takeName{
        @apply font-medium text-white px-1 absolute bottom-0 left-0 z-10 mb-2 ml-2 opacity-75;
        opacity: 0;
    }
    &:hover .takeName{
        opacity: 1;
    }
}
#readyToPlay {
    /* width: 640px; */
    /* height: 365px; */
    position: relative;
}
.video-overlay{
    opacity: 0
}
.video-overlay{
    opacity: 1;
    background: linear-gradient(1deg, #0000006b 10%, transparent, transparent, #00000069 90%);
    transition: opacity 0.1s ease-in-out;
}

.video-controls {
    display: flex;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1rem;
}

.video-controls:hover .slider {
    opacity: 1;
}

/* The slider itself */
.slider {
  -webkit-appearance: none;  /* Override default CSS styles */
  appearance: none;
  width: 100%;
  height: 8px;
  background: #262b73;
  border: 1px solid #001476;
  outline: none;
  border-radius: 5px;
  opacity: 0.8;
    transition: linear 0.1s all;
}

/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
.slider::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
  appearance: none;
  width: 15px; /* Set a specific slider handle width */
  height: 15px; /* Slider handle height */
  background: white; /* Green background */
  cursor: pointer; /* Cursor on hover */
  border-radius: 10px;
  box-shadow: 0px 0px 2px rgba(0,0,0,0.2);
  border: 1px solid gray;
}
</style>
